module.exports = __webpack_public_path__ + "img/ac24693.jpg";